var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "modal",
      class: _vm.modalClass,
      style: { display: _vm.shown ? "block" : "none" },
      attrs: {
        id: _vm.id,
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": _vm.ariaLabelledById,
        "aria-hidden": !_vm.shown,
        "aria-modal": "true",
      },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          ) {
            return null
          }
          return _vm.handleEscape.apply(null, arguments)
        },
        click: function ($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          return _vm.onBackdropClick.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog",
          class: _vm.modalDialogClass,
          attrs: { role: "document" },
        },
        [
          _c(
            "div",
            {
              class: [
                "modal-content",
                { "modal-content--with-image": _vm.withImage },
              ],
            },
            [
              !_vm.noClose
                ? _c(
                    "button",
                    {
                      ref: "closeButton",
                      staticClass: "modal-close",
                      attrs: {
                        type: "button",
                        "data-dismiss": "modal",
                        "aria-label": _vm.i18n.close,
                      },
                      on: { click: _vm.close },
                    },
                    [_c("svg-close")],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.withImage
                ? _c(
                    "div",
                    {
                      class: [
                        "modal-image",
                        { "modal-image--with-error": _vm.imageError },
                      ],
                    },
                    [
                      _vm.$slots["image-top-left-slot"]
                        ? _c(
                            "div",
                            { staticClass: "modal-image__top-left-slot" },
                            [_vm._t("image-top-left-slot")],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.imageError
                        ? _c("svg-profile-media-placeholder", {
                            attrs: { size: 100 },
                          })
                        : _c("img", {
                            style: _vm.imageStyles,
                            attrs: {
                              src: _vm.image.src,
                              width: _vm.image.width || _vm.imageDefaultWidth,
                              height:
                                _vm.image.height || _vm.imageDefaultHeight,
                            },
                            on: {
                              error: function ($event) {
                                _vm.imageError = true
                              },
                            },
                          }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$slots.header
                ? _c("div", { staticClass: "modal-header" }, [
                    _c(
                      "div",
                      {
                        class: [
                          "modal-title",
                          { "modal-title--with-subtitle": _vm.$slots.subtitle },
                        ],
                        attrs: { id: _vm.ariaLabelledById },
                      },
                      [_vm._t("header")],
                      2
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.$slots.subtitle
                ? _c(
                    "div",
                    { staticClass: "modal-subtitle" },
                    [_vm._t("subtitle")],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$slots.carousel
                ? _c("ui-bootstrap-carousel", {
                    staticClass: "modal-carousel",
                    attrs: {
                      id: _vm.id + "-carousel",
                      "auto-slide": _vm.carousel.autoSlide,
                      "with-indicators": _vm.carousel.withIndicators,
                      "buttons-appearance": _vm.buttonsAppearance,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "carousel",
                          fn: function () {
                            return [_vm._t("carousel")]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  })
                : [
                    _vm.$slots.icon
                      ? _c(
                          "div",
                          { staticClass: "modal-icon" },
                          [_vm._t("icon")],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$slots.body
                      ? _c(
                          "div",
                          { staticClass: "modal-body" },
                          [_vm._t("body")],
                          2
                        )
                      : _vm._e(),
                  ],
              _vm._v(" "),
              _vm.$slots.footer
                ? _c(
                    "div",
                    {
                      class: [
                        "modal-footer",
                        {
                          "modal-footer--no-wrap": _vm.footerNoWrap,
                          "d-none":
                            _vm.noConfirm && _vm.noCancel && !_vm.$slots.footer,
                        },
                      ],
                    },
                    [_vm._t("footer")],
                    2
                  )
                : _c(
                    "div",
                    {
                      class: [
                        "modal-footer",
                        {
                          "modal-footer--no-wrap": _vm.footerNoWrap,
                          "d-none": _vm.noConfirm && _vm.noCancel,
                        },
                      ],
                    },
                    [
                      !_vm.noConfirm
                        ? _c(
                            "ui-button",
                            {
                              ref: "confirmButton",
                              attrs: {
                                disabled: _vm.disableConfirm,
                                block: "",
                                uppercase: "",
                                appearance: _vm.buttonsAppearance,
                                "font-weight": "semibold",
                              },
                              on: { click: _vm.confirm },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.i18n.confirm) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.noCancel
                        ? _c(
                            "ui-button",
                            {
                              ref: "cancelButton",
                              attrs: {
                                "data-dismiss": "modal",
                                disabled: _vm.disableCancel,
                                block: "",
                                uppercase: "",
                                "font-weight": "semibold",
                                appearance: _vm.buttonsAppearance,
                                "button-type": "blank",
                              },
                              on: { click: _vm.cancel },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.i18n.cancel) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
            ],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }